<template>
  <div>
    <form
      class="form-inline"
      style="display:flex; justify-content:flex-end; align-items:center; margin-bottom:20px;"
      @submit.stop.prevent="doSearch"
    >
      <div class="input-group" style="display:flex; align-items:center;">
        <input
          v-model="quickSearch"
          type="search"
          placeholder="Quick search"
          style="margin-right:10px;"
          class="form-control"
        />
        <div class="input-group-append">
          <button type="submit" class="btn btn-outline-secondary">
            <i class="mdi mdi-magnify" /> Go
          </button>
        </div>
      </div>
    </form>
    <vdtnet-table
      id="safety-table"
      :fields="fields"
      :opts="opts"
      ref="safety_table"
      class-name="table table-bordered nowrap w-100"
    >
      <template slot="actions" slot-scope="ctx">
        <!-- <span></span> -->
        <button
          class="btn btn-default btn-sm"
          :onclick="`handleclick(${ctx.data})`"
        >
          Edit
        </button>
      </template>
    </vdtnet-table>
    <safety-modal :company="company" @reload-table="reload"></safety-modal>
  </div>
</template>
<script>
import VdtnetTable from "vue-datatables-net";
export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  components: {
    VdtnetTable,
  },
  data() {
    return {
      fields: {
        id: { label: "ID" },
        "job.name": {
          label: "TITLE",
          render: function(data, type, row, meta) {
            return `${row.job.name}`;
          },
        },
        issues: {
          label: "DESCRIPTION",
          render: function(data, type, row, meta) {
            return row.issues;
          },
        },
        safety_status: {
          label: "OUTCOME",
          render: function(data, type, row, meta) {
            return row.safety_status;
          },
        },
        safety_comment: {
          label: "COMMENT",
          render: function(data, type, row, meta) {
            return row.safety_comment;
          },
        },
        actions: {
          label: "ACTIONS",
          searchable: false,
          sortable: false,
          data: "id",
        },
      },
      opts: {
        ajax: {
          url: `/v2/companies/${this.company.id}/safeties`,
          type: "GET",
        },
        searching: true,
        searchDelay: 1500,
        serverSide: true,
        processing: true,
      },
      quickSearch: "",
      isOpen: false,
    };
  },
  methods: {
    reload() {
      this.$refs.safety_table.reload();
    },
    doSearch() {
      this.$refs.safety_table.search(this.quickSearch);
    },
  },
};
</script>
